/* global miLocalization */
import $ from 'jquery';

const sidebarCart = () => {
	const init = () => {
		execute();
	};

	const execute = () => {
		const el = {
			menuCart: '.elementor-menu-cart__main',
			title: $('<div></div>').addClass('custom-cart-title'),
		};

		if ($(el.menuCart).length === 0) return;

		$(function () {
			const cartLocalization =
				typeof window.miLocalization !== 'undefined' &&
				window.miLocalization?.length
					? window.miLocalization['cart']
					: 'SHOPPING CART';

			// Set the title text
			el.title.text(cartLocalization);

			// Insert the title at the top of the menu cart content
			$(el.menuCart).prepend(el.title);
		});
	};

	init();
};

try {
	sidebarCart();
} catch (error) {
	console.error('sidebarCart', error);
}
